module.exports = __webpack_public_path__ + "static/sport/title.85d5aa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jump/title.png
// module id = sfFk
// module chunks = 0